const accountDetails = {
  accountDetails: {
    managePreferences: 'Gerenciar preferências',
    email: 'E-mail',
    emailChangeText: 'Você ainda precisa confirmar a alteração do seu e-mail!',
    confirmationText: 'Enviamos um e-mail de confirmação para %{email}. Você deve clicar no link da mensagem antes que a alteração do e-mail tenha efeito.',
    resendConfirmationEmail: 'Reenviar e-mail de confirmação',
    cancelChange: 'Cancelar esta mudança',
    firstName: 'Primeiro nome',
    lastName: 'Sobrenome',
    phone: 'Telefone',
    company: 'Empresa',
    saveDetails: 'Salvar detalhes da conta',
    changeEmailRequest: 'Mudar e-mail',
    job_profile: {
      label: "Selecionar o perfil profissional da pessoa na empresa",
      tooltip_msg: 'Seleccione o perfil profissional principal da pessoa. Se o utilizador tiver mais do que uma função principal, seleccione "Autres"',
    }
  },
  resetPassword: {
    instructions: 'Sua senha deve ter pelo menos seis caracteres, deve conter pelo menos um número ou caractere especial e não pode ser igual ao seu endereço de e-mail.',
    currentPassword: 'Senha atual',
    newPassword: 'Nova senha',
    confirmNewPassword: 'Confirme a nova senha'
  }
};

export default accountDetails;
